import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { api, formatRand, resolveImageUrl } from "../lib/api";

const OrderSuccess = () => {
  const { orderNumber } = useParams();
  const [search] = useSearchParams();
  const email = search.get("email");
  const yocoLink = search.get("yoco");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!email || !orderNumber) return;
    api.get(`/orders/${orderNumber}`, { params: { email } }).then((r) => setOrder(r.data));
  }, [email, orderNumber]);

  return (
    <div className="section-pad py-24 max-w-2xl mx-auto fade-in" data-testid="order-success-page">
      <h1 className="font-display text-5xl sm:text-7xl uppercase tracking-tighter leading-none">
        Thank you.
      </h1>
      <p className="mt-6 text-sm text-black/65">
        Order <b data-testid="order-number">{orderNumber}</b>.
      </p>

      {order && (
        <div className="mt-12 border hairline" style={{ background: "#fff" }}>
          <ul>
            {order.items.map((it, idx) => (
              <li key={idx} className="px-6 py-5 border-b hairline flex gap-4">
                <div className="w-14 h-16" style={{ background: "var(--bg-alt)" }}>
                  <img src={resolveImageUrl(it.image)} alt="" className="w-full h-full object-cover" />
                </div>
                <div className="flex-1">
                  <div className="font-display text-sm uppercase">{it.name}</div>
                  <div className="text-xs mt-1 text-black/55">{[it.color, it.size].filter(Boolean).join(" · ")} · Qty {it.quantity}</div>
                </div>
                <div className="font-display text-sm">{formatRand(it.price * it.quantity)}</div>
              </li>
            ))}
          </ul>
          <div className="px-6 py-5 flex items-center justify-between">
            <span className="text-sm">Total</span>
            <span className="font-display text-2xl" data-testid="order-total">{formatRand(order.total)}</span>
          </div>
        </div>
      )}

      <div className="mt-10 flex flex-col sm:flex-row gap-3">
        {yocoLink && (
          <a href={yocoLink} target="_blank" rel="noreferrer" className="btn-primary" data-testid="pay-yoco-btn">
            Pay With Yoco
          </a>
        )}
        <Link to="/" className="btn-secondary" data-testid="continue-shopping-btn">Continue</Link>
      </div>
    </div>
  );
};

export default OrderSuccess;
